<script setup>
  import { computed } from 'vue';
  import { useSpotStore } from '@/stores/SpotStore';
  import { useUserStore } from '@/stores/UserStore';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import CompleteReportHeaderActionListBase from "@/components/CompleteReportHeaderActionListBase.vue";
  import FavoriteSpotUserTip from "@/components/FavoriteSpotUserTip.vue";
  import Icon from "@/components/icons/Icon.vue";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW, $SHOW_WIDGETS } = useSettingsGlobals();     

  const showProfileModal = defineModel('showProfileModal', { required: true });

  const spotStore = useSpotStore();
  const userStore = useUserStore();

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const showUserTip = computed(() => userStore.memberLevel > 0 && isDesktop.value && !$WEB_VIEW)

  const alertUrl = computed(() => {
    return spotStore.spot.spot_id
      ? `../en-us/Alerts/ViewAlerts.aspx?spot_id=${spotStore.spot.spot_id}`
      : spotStore.spot.fav_spot_id
      ? `../en-us/Alerts/ViewAlerts.aspx?fav_spot_id=${spotStore.spot.fav_spot_id}`
      : `../en-us/Alerts/ViewAlerts.aspx?lat=${spotStore.lat}&lon=${spotStore.lon}`;
  })  
  
</script>

<template>
  <CompleteReportHeaderActionListBase>
    <template #default="{ classes }">
      <li v-if="userStore.memberLevel > 0" :class="classes.item">
        <button
          @click="showProfileModal = true"
          type="button"
          :class="classes.button"
        >
          <Icon v-if="spotStore.isSpotFavorited" name="star-solid" :class="classes.icon" data-selected />
          <Icon v-else name="star" :class="classes.icon" />
          <span :class="classes.label">Favorite</span>
        </button>
        <FavoriteSpotUserTip v-if="showUserTip" />
      </li>
      <li :class="classes.item">
        <a
          :href="`/map#${spotStore.lat},${spotStore.lon},11`"
          :class="classes.button"
        >
          <Icon name="map-location" :class="classes.icon" style="width: 20px;" />
          <span :class="classes.label">Map</span>
        </a>
      </li>
      <li v-if="userStore.memberLevel > 0" :class="classes.item">
        <a
          :href="alertUrl"
          :class="classes.button"
        >
          <Icon name="bell" :class="classes.icon" />
          <span :class="classes.label">Alerts</span>
        </a>
      </li>
      <li v-if="$SHOW_WIDGETS" :class="classes.item">
        <a
          :href="`/widget/${spotStore.spot.spot_id}`"
          :class="classes.button"
        >
          <Icon name="grid" :class="classes.icon" />
          <span :class="classes.label">Widgets</span>
        </a>
      </li>
    </template>
  </CompleteReportHeaderActionListBase>
</template>